module.exports = __webpack_public_path__ + "static/media/lp-plan-01.fdd59c6a.png";